<template>
  <span style="line-height: 1px;"><hy-check-box :id="id" v-model="(attribute.ref.value as boolean)" :disabled="isReadOnly"/></span>
</template>

<script lang="ts">

import Attribute from "../../xmlrdb-data/Attribute"
import HyCheckBox from "../../basic-components/HyCheckBox.vue";
export default {
	
  name: "checkboxField",
  props: {
    attribute: Attribute,
    isReadOnly: Boolean,
    id: String
  },
  components: {
    HyCheckBox
  },
  // Steuert in der Attribute - Komponente ob das erzeugte Label als Click-Label für die Input-Komponente agieren soll
  clickableAttributeLabel: true, 
  setup(props){
    return {
      //attributex : props.attribute
    }
  }
}

</script>

<style scoped>
</style>